import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';
import './Header.css';

export function Header() {
  const { darkMode, toggleDarkMode } = useTheme();
  const { user, logout } = useAuth();
  const location = useLocation();
  const [shareFeedback, setShareFeedback] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleShareUrl = async () => {
    const url = window.location.origin + location.pathname;
    try {
      await navigator.clipboard.writeText(url);
      setShareFeedback(true);
      setTimeout(() => setShareFeedback(false), 2000);
    } catch (err) {
      setShareFeedback(false);
    }
  };

  return (
    <header className="header">
      <Link to="/" className="header-logo" aria-label="Letter Quest home">
        <img
          className="header-logo-img"
          src={`${process.env.PUBLIC_URL}/branding/app-icon-foreground.png`}
          alt=""
          width={36}
          height={36}
          decoding="async"
          aria-hidden="true"
        />
        <span className="header-logo-text">Letter Quest</span>
      </Link>
      <button
        type="button"
        className="header-menu-btn"
        onClick={() => setMenuOpen((o) => !o)}
        aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={menuOpen}
      >
        {menuOpen ? '✕' : '☰'}
      </button>
      <nav className={`header-nav ${menuOpen ? 'header-nav--open' : ''}`} aria-label="Site">
        <div className="header-nav__links">
          <Link
            to="/leaderboard"
            className={`header-link ${location.pathname === '/leaderboard' ? 'active' : ''}`}
            onClick={() => setMenuOpen(false)}
          >
            Leaderboard
          </Link>
          <Link
            to="/faq"
            className={`header-link ${location.pathname === '/faq' ? 'active' : ''}`}
            onClick={() => setMenuOpen(false)}
          >
            FAQ
          </Link>
          <Link
            to="/about"
            className={`header-link ${location.pathname === '/about' ? 'active' : ''}`}
            onClick={() => setMenuOpen(false)}
          >
            About
          </Link>
          <Link
            to="/feedback"
            className={`header-link ${location.pathname === '/feedback' ? 'active' : ''}`}
            onClick={() => setMenuOpen(false)}
          >
            Feedback
          </Link>
          <Link
            to="/apps"
            className={`header-link ${location.pathname === '/apps' ? 'active' : ''}`}
            onClick={() => setMenuOpen(false)}
          >
            Get the app
          </Link>
          <Link
            to="/account-deletion"
            className={`header-link ${location.pathname === '/account-deletion' ? 'active' : ''}`}
            onClick={() => setMenuOpen(false)}
          >
            Account deletion
          </Link>
        </div>

        <div className="header-nav__actions">
          <button
            type="button"
            className="header-share-btn"
            onClick={handleShareUrl}
            aria-label="Share page URL"
            title="Copy page URL"
          >
            {shareFeedback ? '✓' : '⎘'}
          </button>
          <button
            type="button"
            className="header-theme-btn"
            onClick={toggleDarkMode}
            aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            {darkMode ? '☀' : '☽'}
          </button>
          {user ? (
            <>
              <Link to="/account" className="header-link" onClick={() => setMenuOpen(false)}>
                Account
              </Link>
              <button type="button" className="header-link header-logout" onClick={logout}>
                Log Out
              </button>
            </>
          ) : (
            <Link to="/login" className="header-link header-cta" onClick={() => setMenuOpen(false)}>
              Sign In
            </Link>
          )}
        </div>
      </nav>
    </header>
  );
}
